import { render } from "./LinkUserPortal.vue?vue&type=template&id=4fadf851"
import script from "./LinkUserPortal.vue?vue&type=script&lang=js"
export * from "./LinkUserPortal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__